(() => {
  const SELECTOR = '.shopify-section';
  const CLASS_INIT = 'fade-up-init';
  const CLASS_SHOW = 'fade-up-show';

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add(CLASS_SHOW);
        io.unobserve(entry.target);
      });
    },
    {
      threshold: 0.15,                 
      rootMargin: '0px 0px -30px 0px' 
    }
  );

  function revealIfVisible(el) {
    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) {
      el.classList.add(CLASS_SHOW);
      return true;
    }
    return false;
  }

  function observeSections(root = document) {
    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (el.classList.contains(CLASS_INIT) || el.classList.contains(CLASS_SHOW)) return;
      el.classList.add(CLASS_INIT);

      if (revealIfVisible(el)) return; // fallback per elementi già visibili
      io.observe(el);
    });
  }

  function revealAllIfAtPageBottom() {
    const atBottom =
      window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
    if (!atBottom) return;
    document.querySelectorAll(`.${CLASS_INIT}:not(.${CLASS_SHOW})`)
      .forEach((el) => el.classList.add(CLASS_SHOW));
  }

  document.addEventListener('DOMContentLoaded', () => observeSections());
  document.addEventListener('shopify:section:load', (e) => observeSections(e.target));
  window.addEventListener('scroll', revealAllIfAtPageBottom, { passive: true });
  window.addEventListener('load', revealAllIfAtPageBottom);
})();
